import {
    IServerResponse,
} from "Model/ServerResponse";
import { ServicesUtility } from "./servicesUtility";

export class CommonService {
    private static instance: CommonService;

    private constructor() { }

    public static getInstance(): CommonService {
        if (!this.instance) {
            this.instance = new CommonService();
        }

        return this.instance;
    }
    public async getQuestCertificationData(
        sourcesystemName: string,
        systemName: string,
        acitivityName: string,
        country: string,
        gin: string,
        toDate: string
    ): Promise<IServerResponse<any>> {
        let token = await ServicesUtility.getGraphToken();
        if (!token) {
            throw new Error('Failed to get authentication token');
          }
        let url = ServicesUtility.prefixBaseUrl(
            `api/approvals/${sourcesystemName}/${systemName}/${acitivityName}?country=${country}&empNo=${gin}&toDate=${toDate}`
        );
        let requestOptions = {
            method: "GET",
            headers: {
                ...ServicesUtility.getDefaultHeaders(token),
            },
        };
        let result: IServerResponse<any> = {
            statusCode: 0,
            payload: null,
            errorMessage: "",
        };
        return ServicesUtility.timedRequest(
            ServicesUtility.Min5,
            url,
            requestOptions
        ).then(
            async (response) => {
                try {
                    result.statusCode = response.status;
                    let x = await response.json();
                    result.payload = x;
                    return result;
                } catch (error) {
                    result.statusCode = response.status;
                    result.errorMessage = response.statusText;
                    return result;
                }
            },
            (error: Error) => {
                result.errorMessage = error.message;
                return result;
            }
        );
    }


    public async getForwardApprovers(
        systemName: string,
        acitivityName: string,
        search: string,
        signal: any,
    ): Promise<IServerResponse<any>> {
        let token = await ServicesUtility.getGraphToken();
        if (!token) {
            throw new Error('Failed to get authentication token');
          }
        let url = ServicesUtility.prefixBaseUrl(
            `api/approvals/${systemName}/${acitivityName}/forward?search=${search}`
        );
        let requestOptions = {
            method: "GET",
            signal,
            headers: {
                ...ServicesUtility.getDefaultHeaders(token),
            },
        };
        let result: IServerResponse<any> = {
            statusCode: 0,
            payload: null,
            errorMessage: "",
        };
        return ServicesUtility.timedRequest(
            ServicesUtility.Min5,
            url,
            requestOptions
        ).then(
            async (response) => {
                try {
                    result.statusCode = response.status;
                    let x = await response.json();
                    result.payload = x;
                    return result;
                } catch (error) {
                    result.statusCode = response.status;
                    result.errorMessage = response.statusText;
                    return result;
                }
            },
            (error: Error) => {
                result.errorMessage = error.message;
                return result;
            }
        );
    }
}

